export function getProvenanceLabel(
  project?: {
    repositoryUrl?: string | null;
    githubRepositoryId?: string | null;
    productUrl?: string | null;
  } | null,
  lastAnalysis?: { completedAt?: string | Date | null } | null,
): string {
  const hasRepo = Boolean(
    project?.githubRepositoryId || project?.repositoryUrl,
  );
  if (hasRepo && lastAnalysis?.completedAt) {
    return `Last analyzed from repository ${formatRelativeTime(new Date(lastAnalysis.completedAt))}`;
  }
  if (hasRepo) {
    const cleanRepo = project?.repositoryUrl
      ? project.repositoryUrl.replace(/^https?:\/\/(www\.)?github\.com\//, "")
      : "Connected repository";
    return `Repository: ${cleanRepo}`;
  }
  if (project?.productUrl) {
    const host = project.productUrl
      .replace(/^https?:\/\/(www\.)?/, "")
      .replace(/\/.*$/, "");
    return `Seeded from ${host}`;
  }
  return "Custom domain context";
}

export function formatRelativeTime(date: Date): string {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}
